import React from "react"
import PropTypes from "prop-types"
import lottie from 'lottie-web';
import BackgroundModal from '../app_components/BackgroundModal'
import Modal from '../app_components/Modal'

class LexicoinAlert extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      show: true,
      id: ''
    }

    this.toggleAlert = this.toggleAlert.bind(this)
    this.loadLottie = this.loadLottie.bind(this)
  }

  loadLottie() {
    lottie.loadAnimation({
      container: document.getElementById('confetti'),
      name: 'lexicoinConfetti',
      renderer: 'svg',
      loop: false,
      autoplay: true,
      path: this.props.confettiLottie
    });
  }

  componentDidMount() {
    this.setState({
      show: true,
      id: this.props.points.id
    })
    this.loadLottie()
  }

  componentDidUpdate() {
    if(this.state.id != this.props.points.id) {
      this.setState({
        id: this.props.points.id,
        show: true
      }, () => this.loadLottie())
    }
  }

  componentWillUnmount() {
    this.setState = {
      show: false,
      id: ''
    }
  }

  toggleAlert() {
    this.setState({
      show: false
    })
    this.props.deleteNotification(this.state.id)
  }

  render() {
      if(this.state.show === false) {
        return null
      } else {
      return(
          <BackgroundModal onClick={() => this.toggleAlert()}>
            <Modal>
              <h3 className="modalHeader" style={{paddingTop: 15}}>You earned {this.props.points.value} {this.props.points.value === 1 ? "Lexicoin" : "Lexicoins"}!</h3>
              <h5 className="modalSubHeader" style={{
                  marginTop: 15
              }}>{this.props.points.notes}</h5>
              <img src={this.props.lexicoin} style={{height: 200, borderRadius: 100, marginTop: 50}}/>
              <div style={{justifyContent: 'center', height: 300, marginTop: -250}} id="confetti">
              </div>
            </Modal>
          </BackgroundModal>
      )
    }
  }
}

export default LexicoinAlert;
